// src/store/slices/advisorSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as con from "../../GlobalConstants";
import axios from "axios";
import { getRequestConfig, getVisualizedUser } from "../logic/supportFunctions";
import { createError, createNotification } from "../../templates/notifications/Notifications";
import { extractErrorMessage } from "../../utils/errorFunctions";

export const fetchAdvisors = createAsyncThunk(
  "advisor/fetchAdvisors",
  async (_, { rejectWithValue }) => {
    try {
      const config = getRequestConfig();

      const url = con.rest_base_url + con.advisors_api;

      const res = await axios.get(url, config);

      return res.data;
    } catch (err) {
      return rejectWithValue(extractErrorMessage(err));
    }
  }
);

// ADD ADVISOR
export const addAdvisor = createAsyncThunk(
  "advisor/addAdvisor",
  async (idAdvisor, { rejectWithValue }) => {
    try {
      const config = getRequestConfig();

      const data = {
        [con.USER]: getVisualizedUser()[con.ID],
        [con.ADVISOR]: idAdvisor,
        [con.IS_MAIN_ADVISOR]: false,
      };

      const url = con.rest_base_url + con.add_advisors_api;

      await axios.post(url, data, config);

      return idAdvisor;
    } catch (err) {
      return rejectWithValue(extractErrorMessage(err));
    }
  }
);

// SET MAIN ADVISOR
export const setMainAdvisor = createAsyncThunk(
  "advisor/setMainAdvisor",
  async (idAdvisor, { rejectWithValue }) => {
    try {
      const config = getRequestConfig();

      const data = {
        [con.USER]: getVisualizedUser()[con.ID],
        [con.ADVISOR]: idAdvisor,
        [con.IS_MAIN_ADVISOR]: true,
      };

      const url = con.rest_base_url + con.add_advisors_api;

      await axios.post(url, data, config);

      return idAdvisor;
    } catch (err) {
      return rejectWithValue(extractErrorMessage(err));
    }
  }
);

// DELETE ADVISOR
export const deleteAdvisor = createAsyncThunk(
  "advisor/deleteAdvisor",
  async (idAdvisor, { rejectWithValue }) => {
    try {
      const config = getRequestConfig();

      const data = {
        [con.USER]: getVisualizedUser()[con.ID],
        [con.ADVISOR]: idAdvisor,
      };

      const url = con.rest_base_url + con.delete_advisors_api;

      await axios.post(url, data, config);

      return idAdvisor;
    } catch (err) {
      return rejectWithValue(extractErrorMessage(err, "Error al eliminar asesor"));
    }
  }
);


const initialState = {
  [con.REDUCER_ADVISORS]: [],
  advisors_status: con.NOT_STARTED,
  advisor_action_status: con.NOT_STARTED
  
};

const advisorSlice = createSlice({
  name: con.REDUCER_ADVISORS, 
  initialState,

  reducers: {

  },

    extraReducers: (builder) => {
    builder

        // FETCH
        .addCase(fetchAdvisors.pending, (state) => {
          state.advisors_status = con.LOADING;
        })
        .addCase(fetchAdvisors.fulfilled, (state, action) => {
          state.advisors_status = con.OK;
          state.advisors = action.payload;
        })
        .addCase(fetchAdvisors.rejected, (state, action) => {
          state.advisors_status = con.ERROR;
          createError(action.payload)
        })

        // ADD
        .addCase(addAdvisor.pending, (state) => {
          state.advisor_action_status = con.LOADING;
        })
        .addCase(addAdvisor.fulfilled, (state, action) => {
          state.advisor_action_status = con.OK;
          state.advisors.push(action.payload);
          createNotification("Asesor agregado correctamente", con.NOTIFICATION_TIME_SHORT);
        })
        .addCase(addAdvisor.rejected, (state, action) => {
          state.advisor_action_status = con.ERROR;
          createError(action.payload)
        })

        // SET MAIN
        .addCase(setMainAdvisor.pending, (state) => {
          state.advisor_action_status = con.LOADING;
        })
        .addCase(setMainAdvisor.fulfilled, (state, action) => {
          state.advisor_action_status = con.OK;

          const id = action.payload;

          state.advisors = state.advisors.map((adv) => ({
                ...adv,
                [con.IS_MAIN_ADVISOR]: adv[con.ID] === id,
            }));
          createNotification("Asesor principal actualizado", con.NOTIFICATION_TIME_SHORT);
        })
        .addCase(setMainAdvisor.rejected, (state, action) => {
          state.advisor_action_status = con.ERROR;
          createError(action.payload);
        })

        // DELETE
        .addCase(deleteAdvisor.pending, (state) => {
          state.advisor_action_status = con.LOADING;
        })
        .addCase(deleteAdvisor.fulfilled, (state, action) => {
          state.advisor_action_status = con.OK;
          state.advisors = state.advisors.filter(
              (adv) => adv[con.ID] !== action.payload
          );
          createNotification("Asesor eliminado correctamente", con.NOTIFICATION_TIME_SHORT);
        })
        .addCase(deleteAdvisor.rejected, (state, action) => {
          state.advisor_action_status = con.ERROR;
          createError(action.payload)
        });
    }
});


export default advisorSlice.reducer;